import HeaderFilter from '../../../components/HeaderFilter';
import DisplayTable from '../../../components/core/DisplayTable';
import GenericForm from '../../../components/core/GenericForm';
import { useAuthStore } from '../../../store';

const PositionPage = () => {
  const api = '/hr/positions';
  const moduleName = 'Position';
  const moduleCode = 'POST';
  const { user } = useAuthStore();
  const userModuleAccess = user?.moduleAccess?.find(
    (item) => item.module.code === moduleCode,
  );
  return (
    <>
      <div className={'page-wrapper'}>
        <HeaderFilter showCreate={userModuleAccess?.create} />
        <DisplayTable
          api={api}
          moduleName={moduleName}
          canDelete={userModuleAccess?.delete}
          canEdit={userModuleAccess?.write}
          userRole={user?.role}
        />
        <GenericForm api={api} moduleName={moduleName} />
      </div>
    </>
  );
};

export default PositionPage;
